import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const KindersleyRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.kindersley"
        components={{
          mail: (
            <a
              href={`mailto: anthony.vicenzino@siemenstransport.com`}
              className="email_space"
            >
              anthony.vicenzino@siemenstransport.com
            </a>
          ),
        }}
      />
    </div>
  );
};

export default KindersleyRequirements;
